// extracted by mini-css-extract-plugin
module.exports = {"lower":"lower__uBEaG","upper":"upper__U_IM0","label":"label__1LWK0"};